import React, { Dispatch, SetStateAction } from "react"
import dayjs from "dayjs"
import { useQuery } from "@apollo/client"
import { useAppDispatch } from "lib/store"
import { showEditSidebar } from "lib/store/services/editSidebar/slice"

import GET_CUSTOM_GIFT_CARD_CONFIG from "graphql/queries/config/GetCustomGiftCardConfig"

import { Name } from "components/Ui/Table/Shared.styled"

import TableRow from "components/Ui/Table/TableRow"
import { BlurRow } from "components/Ui/Table/TableBlurLoading"

import { ReactComponent as CardIcon } from "images/icons/credit-card.svg"

export const getLoadingRow = () => (
  <>
    <CardIcon />
    <div>
      <div>
        <Name>custom-gift-card-id</Name>
      </div>
    </div>
    <div className="hideOnSmallScreens">
      <p>https://baseurl.se</p>
    </div>
    <div className="hideOnSmallScreens">
      <p>https://tokenurl.se</p>
    </div>
    <div className="hideOnSmallScreens hideOnMediumScreens">
      <p>2000-00-00</p>
    </div>
    <div className="hideOnSmallScreens hideOnMediumScreens">
      <p>2000-00-00</p>
    </div>
  </>
)

type Props = {
  id: string
  setEditId?: Dispatch<SetStateAction<string>>
}

export const CustomGiftCardConfigTableRow = ({ id, setEditId }: Props) => {
  const dispatch = useAppDispatch()

  const { data, loading } = useQuery(GET_CUSTOM_GIFT_CARD_CONFIG, {
    variables: { id: id }
  })

  const customConfig = data?.getBSGGiftCardConfig
  if (loading) return <BlurRow>{getLoadingRow()}</BlurRow>
  return (
    <TableRow
      key={id}
      handleOnClick={() => {
        if (setEditId) setEditId(customConfig.id)
        dispatch(showEditSidebar())
      }}
    >
      <CardIcon />
      <div>
        <div>
          <Name>{customConfig?.id}</Name>
        </div>
      </div>
      <div className="hideOnSmallScreens">
        <p>{customConfig?.baseUrl}</p>
      </div>
      <div className="hideOnSmallScreens">
        <p>{customConfig?.tokenUrl}</p>
      </div>
      <div className="hideOnSmallScreens hideOnMediumScreens">
        <p>{dayjs(customConfig?.created).format("YYYY-MM-DD")}</p>
      </div>
      <div className="hideOnSmallScreens hideOnMediumScreens">
        <p>{dayjs(customConfig?.updated).format("YYYY-MM-DD")}</p>
      </div>
    </TableRow>
  )
}
